import type { InGameTimeData, TimeOfDayPeriod } from '@danda/shared';

/** Convert absolute game time in seconds to InGameTimeData for display */
export function secondsToTimeData(totalSeconds: number): InGameTimeData {
  const day = Math.floor(totalSeconds / 86400);
  const remaining = totalSeconds % 86400;
  const hour = Math.floor(remaining / 3600);
  const minute = Math.floor((remaining % 3600) / 60);
  const periods: [number, number, TimeOfDayPeriod][] = [
    [6, 11, 'morning'],
    [12, 17, 'afternoon'],
    [18, 21, 'evening'],
  ];
  const timeOfDay: TimeOfDayPeriod =
    periods.find(([min, max]) => hour >= min && hour <= max)?.[2] ?? 'night';
  return {
    formatted: `Day ${day + 1} ${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`,
    day,
    hour,
    minute,
    timeOfDay,
  };
}
